import { toast } from 'react-toastify'
import { AxiosError } from 'axios'
import { Store } from 'redux'

import { IApplicationState } from 'setup/store'

import { LocaleErrorStatusMessageKeysType } from 'shared/locale/en-US'
import { IListOfErrors } from 'shared/models/AppError'
import { replacePlaceholders } from 'shared/utils/replacePlaceholders'

import { logout, refreshSession } from 'features/auth/actions'

import { getIsRefreshTokenExpired } from 'components/SessionPolling/utils'

import { LOGOUT_RESPONSE_CODE } from './constants'
import { authExcluding } from './helpers/authExcluding'
import { checkIsMultiError } from './helpers/checkIsMultiError'
import { convertInvalidField } from './helpers/convertInvalidField'

export const makeUnauthorizedInterceptor = (store: Store<IApplicationState, any>) => (error: AxiosError) => {
  const state = store.getState()
  const localeErrors = state.locale.data.errorStatusMessage

  const { isAuth } = state.auth.data

  // sessions
  if (isAuth) {
    if (error.response?.data?.code === LOGOUT_RESPONSE_CODE) {
      store.dispatch(logout.success())
    } else if (error.response?.status === 401) {
      const { session } = store.getState().auth.data

      if (session) {
        const isRefreshTokenExpired = getIsRefreshTokenExpired(session.refresh)

        if (isRefreshTokenExpired) {
          store.dispatch(logout.success())
        } else {
          setTimeout(() => store.dispatch(refreshSession()), 0)
        }
      } else {
        store.dispatch(logout.success())
      }
    }
  }

  if (error.request?.responseURL?.includes?.('accounts/login')) {
    const isAuthError = authExcluding(error, store)

    if (isAuthError) {
      throw new Error(JSON.stringify(error.response?.data || ''))
    }
  }

  if (error.response?.status !== 500 && checkIsMultiError(error)) {
    const convertedField: IListOfErrors = convertInvalidField(error)

    convertedField.listOfErrors.forEach(err => {
      const errorMessage =
        localeErrors[err.code as LocaleErrorStatusMessageKeysType] ||
        err.message ||
        err.detail ||
        localeErrors.defaultMessage

      toast.error(errorMessage, { toastId: errorMessage })
    })

    throw new Error(JSON.stringify(convertedField) || '')
  }

  if (error.response) {
    if (error.response.status === 401) {
      throw new Error(error.message)
    }

    const errorMessage =
      replacePlaceholders(localeErrors[error.response?.data?.code as LocaleErrorStatusMessageKeysType], {
        ...(error.response?.data?.extra || {}),
      }) ||
      error.response?.data?.message ||
      error.response?.data?.detail ||
      localeErrors.defaultMessage
    toast.error(errorMessage, { toastId: errorMessage })
  }

  throw new Error(JSON.stringify(error.response?.data || ''))
}
